import React from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { ReactComponent as IconCheck18 } from "../../icons/icon/18/a-icon-check-18.svg";
import FilterTag from "../filterTag/filterTag";
import NavigationLink from "../navigation/navigationLink";

import "./universalNavigation.scss";

const UniversalNavigation = ({
  description,
  dkmsFamily,
  donorCenter,
  headline,
  icon = null,
}) => {
  const site = process.env.GATSBY_SITE;

  return (
    <Row className="universal-navigation">
      <Col xl={7}>
        <div className="universal-navigation__headline typo-title1">
          {headline}
        </div>
        <div className="typo-body1">
          {description}
        </div>
      </Col>
      <Col xl={5} className="order-first order-xl-0 text-xl-right">
        {icon}
      </Col>
      <Col className="universal-navigation__sites donor-center" md={6}>
        <h4><FormattedMessage id="navigation.dkms_donor_centers" /></h4>
        <div className="d-flex flex-column">
          {donorCenter.map((item) => (
            <React.Fragment key={item.id}>
              <NavigationLink href={item.href} className="typo-label">
                {item.icon}<span>{item.text}</span>
              </NavigationLink>
              {item.selected && (
                <div>
                  <FilterTag icon={<IconCheck18 />}>
                    <FormattedMessage id="navigation.you_are_here" />
                  </FilterTag>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Col>
      <Col className="universal-navigation__sites" md={6}>
        <h4><FormattedMessage id="navigation.dkms_family" /></h4>
        <div className="d-flex flex-column">
          {dkmsFamily.map((item) => (
            <React.Fragment key={item.id}>
              <NavigationLink href={item.href} key={item.id} className="typo-label">
                {item.icon}{item.text}
              </NavigationLink>
              {(
                (item.href === "http://professional.dkms.org/" && site === "prof")
                || (item.href.includes("dkms-lab.de") && site === "labs")
              ) && (
                <div>
                  <FilterTag icon={<IconCheck18 />}>
                    <FormattedMessage id="navigation.you_are_here" />
                  </FilterTag>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Col>
    </Row>
  );
};

UniversalNavigation.propTypes = {
  description: PropTypes.string.isRequired,
  dkmsFamily: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  donorCenter: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  headline: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.object]),
};

export default UniversalNavigation;
